import { Routes } from "@angular/router";

import { RoleGuard, RoleGuardConfig } from "src/modules/app/guards/role.guard";

import { addSlugRedirects, SLUGS } from "#shared/slugs";

import { HomeLayoutComponent } from "#modules/layouts/components/home-layout/home-layout.component";
import { PageNotFoundComponent } from "#modules/layouts/components/page-not-found/page-not-found.component";
import { SingleLayoutComponent } from "#modules/layouts/components/single-layout/single-layout.component";
import { Outlets } from "#modules/layouts/outlets";
import { LibrarySidenavComponent } from "#modules/library/components/library-sidenav/library-sidenav.component";
import { nodeRedirectGuard } from "#modules/shared/guards/external-redirect.guard";

import { MissingRoleDialogComponent } from "./components/missing-role-dialog/missing-role-dialog.component";

export const routes = addSlugRedirects(
  [
    {
      path: "",
      pathMatch: "full",
      redirectTo: SLUGS.home,
    },
    {
      path: "",
      component: HomeLayoutComponent,
      children: [
        {
          outlet: Outlets.SideNav,
          path: "",
          component: LibrarySidenavComponent,
        },
        {
          path: SLUGS.home,
          loadChildren: () => import("#modules/home/home.module").then((m) => m.HomeModule),
        },
        {
          path: "page",
          loadChildren: () => import("#modules/pages/pages.module").then((m) => m.PagesModule),
        },
        {
          path: "library",
          canActivateChild: [nodeRedirectGuard],
          loadChildren: () => import("#modules/pdf-viewer/pdf-viewer.module").then((m) => m.PdfViewerModule),
        },
        {
          path: "search",
          loadChildren: () => import("#modules/search/search.module").then((m) => m.SearchModule),
        },
      ],
    },
    {
      component: HomeLayoutComponent,
      path: "editor",
      loadChildren: () => import("#modules/editor/editor.module").then((m) => m.EditorModule),
      canActivate: [RoleGuard],
      canActivateChild: [RoleGuard],
      data: {
        roleGuardConfig: {
          roles: { some: ["Editor"] },
          dialog: MissingRoleDialogComponent,
        },
      } as RoleGuardConfig,
    },
    {
      path: "**",
      component: SingleLayoutComponent,
      children: [
        {
          path: "",
          component: PageNotFoundComponent,
        },
      ],
    },
  ] satisfies Routes,
  SLUGS,
  ["home"]
);
